import { AuthResponseStatus } from '@/enums/AuthResponseStatus';
import Response from '@/models/Response';

export default class UserResponse extends Response {
  public static buildSuccesResponse(accessToken: string, messageEN: string, messageNL: string): Response {
    return new Response(AuthResponseStatus.SUCCESS, accessToken, messageEN, messageNL);
  }

  public static buildFailedResponse(messageEN: string, messageNL: string): Response {
    return new Response(AuthResponseStatus.FAILED, '', '', messageEN, messageNL);
  }
}
